import clsx from "clsx";
import { ShapeProps } from "./types";
import SpadeIcon from "@mixitone/icons/shape-spade.svg";

export const Spade: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <SpadeIcon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span
        className="relative font-bold"
        style={{
          fontSize: `${size / 2}px`,
        }}
      >
        {children}
      </span>
    </div>
  );
};
